"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = require('boolean'),
    parseBoolean = _require["boolean"];
/**
 * @class
 * @param {Object} params
 * @param {Boolean} params.showToCustomers - should it be shown to customers?
 * @param {Boolean} params.active - should it be used internally?
 * @param {String} params.title - e.g. "Priority Mail"
 * @param {Number} params.rate - cost in dollars
 * @param {Number} params.freeRate - 0.00 for options that qualify for free shipping, this.rate for options that don't
 * @param {String} params.description - e.g. "Estimated transit time of 2-3 business days."
 * @param {Number} params.transitTime - expected days in transit
 */


var ShippingOption = function ShippingOption() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, ShippingOption);

  this.showToCustomers = parseBoolean(params.showToCustomers) || true;
  this.active = parseBoolean(params.active) || true;
  this.title = params.title || '';
  this.rate = params.rate || 0.00;
  this.freeRate = params.freeRate || 0.00;
  this.description = params.description || 'Description not provided';
  this.transitTime = params.transitTime || 0;
};

module.exports = ShippingOption;